import { Reveal } from "./Reveal";

const STEPS = [
  {
    title: "1. Brief & Discovery",
    body: "We understand your lifestyle, functional pain points, storage demands, and target budget.",
    testId: "process-step-1",
  },
  {
    title: "2. Concept & 3D",
    body: "Detailed spatial layouts, moodboards, material swatches, and realistic 3D visualizations.",
    testId: "process-step-2",
  },
  {
    title: "3. Turnkey Execution",
    body: "Civil modifications, electrical grids, modular woodwork, and custom furniture craftsmanship.",
    testId: "process-step-3",
  },
  {
    title: "4. Styling & Handover",
    body: "Curtains, light installations, deep cleaning, and a ready-to-live-in handover ceremony.",
    testId: "process-step-4",
  },
];

export const Process = () => (
  <section className="py-24 px-6 md:px-10 bg-[#0D2121] text-[#FAF6F0]" data-testid="process-section">
    <div className="max-w-7xl mx-auto space-y-16">
      <Reveal className="max-w-2xl space-y-4">
        <span className="text-xs uppercase tracking-widest text-[#E2A435] font-semibold">How We Work</span>
        <h2 className="font-display text-3xl sm:text-4xl text-[#FAF6F0]">From First Sketch to Final Cushion</h2>
        <p className="text-[#EADBC8]/80 text-base">Clear milestones so you are never left guessing about timelines, vendor budgets, or design alignment.</p>
      </Reveal>

      <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
        {STEPS.map((step, i) => (
          <Reveal key={step.title} delay={i * 100}>
            <div className="border-t border-[#FAF6F0]/20 pt-6 space-y-3" data-testid={step.testId}>
              <span className="w-2.5 h-2.5 rounded-full bg-[#E2A435] inline-block"></span>
              <h3 className="font-display text-xl text-[#FAF6F0]">{step.title}</h3>
              <p className="text-sm text-[#EADBC8]/70 leading-relaxed">{step.body}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
